import { gql } from "@apollo/client";

export const WISHLIST_PRODUCT_DETAILS_QUERY = gql`
  query ($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on ProductVariant {
        id
        priceV2 {
          amount
        }
        compareAtPriceV2 {
          amount
        }
        selectedOptions {
          name
          value
        }
        product {
            vendor
            tags
        }
        availableForSale
        baseColor: metafield(namespace: "color", key: "base_color") {
          key
          value
        }
      }
    }
  }
`;
